import React, { memo } from 'react';
import { Book } from 'lucide-react';
export function PackContents() {
  const tomos = [{
    title: 'Aquí y Ahora',
    desc: 'presencia real en lo cotidiano'
  }, {
    title: 'Citas que se recuerdan',
    desc: 'tiempo uno a uno'
  }, {
    title: 'Hablemos de lo que importa',
    desc: 'conversaciones profundas'
  }, {
    title: 'Jugamos, reímos, recordamos',
    desc: 'juego sin pantallas'
  }, {
    title: 'Recuerdos que quedan',
    desc: 'memoria emocional familiar'
  }, {
    title: 'Nuestro legado',
    desc: 'palabras que acompañan toda la vida'
  }];
  return <section className="py-8 px-4 bg-gradient-to-b from-amber-50/50 to-rose-50/40" data-id="element-120">
      <div className="max-w-3xl mx-auto" data-id="element-121">
        <h2 className="text-3xl font-bold text-gray-900 mb-4 text-center" data-id="element-122">
          📚 ¿Qué incluye exactamente el pack?
        </h2>

        <p className="text-center text-xl font-bold text-gray-700 mb-4" data-id="element-123">
          6 TOMOS DIGITALES GUIADOS:
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3" data-id="element-124">
          {tomos.map((tomo, idx) => <div key={idx} className="bg-white p-4 rounded-xl shadow-sm border border-gray-100 flex items-start gap-3" data-id="element-125">
              <div className="bg-green-100 p-2 rounded-lg shrink-0" data-id="element-126">
                <Book className="w-6 h-6 text-green-700" data-id="element-127" />
              </div>
              <div data-id="element-128">
                <h3 className="font-bold text-lg text-gray-900" data-id="element-129">
                  {tomo.title}
                </h3>
                <p className="text-gray-600" data-id="element-130">{tomo.desc}</p>
              </div>
            </div>)}
        </div>

        <p className="text-center mt-6 text-lg italic text-gray-600" data-id="element-131">
          Todo pensado para familias reales, con poco tiempo y mucho amor.
        </p>
      </div>
    </section>;
}